import { WhatsappLogo, EnvelopeSimple, Lightning } from "@phosphor-icons/react";

const CHANNELS = {
  whatsapp: {
    bg: "bg-[#25D366]",
    label: "WhatsApp",
    Icon: WhatsappLogo,
  },
  email: {
    bg: "bg-[#3B82F6]",
    label: "Email",
    Icon: EnvelopeSimple,
  },
  simulator: {
    bg: "bg-[#7C3AED]",
    label: "Simulator",
    Icon: Lightning,
  },
};

export default function ChannelAvatar({ channel, name, size = 40 }) {
  const c = CHANNELS[channel] || CHANNELS.simulator;
  const Icon = c.Icon;
  const initials = (name || "?")
    .split(" ")
    .map((w) => w[0])
    .filter(Boolean)
    .slice(0, 2)
    .join("")
    .toUpperCase();
  return (
    <div className="relative shrink-0" style={{ width: size, height: size }}>
      <div
        className="w-full h-full rounded-full bg-muted flex items-center justify-center text-foreground/70 font-medium"
        style={{ fontSize: size * 0.4 }}
      >
        {initials}
      </div>
      <div
        className={`absolute -bottom-0.5 -right-0.5 ${c.bg} text-white rounded-full flex items-center justify-center ring-2 ring-white`}
        style={{
          width: size * 0.42,
          height: size * 0.42,
        }}
        title={c.label}
      >
        <Icon size={size * 0.26} weight="fill" />
      </div>
    </div>
  );
}

export function ChannelBadge({ channel, withLabel = true, size = 14 }) {
  const c = CHANNELS[channel] || CHANNELS.simulator;
  const Icon = c.Icon;
  return (
    <span className="inline-flex items-center gap-1.5 text-xs font-medium">
      <span
        className={`${c.bg} text-white rounded-full flex items-center justify-center`}
        style={{ width: size + 6, height: size + 6 }}
      >
        <Icon size={size} weight="fill" />
      </span>
      {withLabel && <span>{c.label}</span>}
    </span>
  );
}
